(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onami-home"] && !Shopify.designMode) return;
  try {
    
/* ONAMI: progressive enhancement; Shopify editor safe and dependency free. */
(() => {
  if (window.__onamiHomeLoaded) return;
  window.__onamiHomeLoaded = true;
  const active = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mount = root => {
    if (active.has(root)) return;
    const events = new AbortController();
    const signal = events.signal;
    const button = root.querySelector('[data-motion-toggle]');
    const enabledByMerchant = root.dataset.motion !== 'off';
    let paused = !enabledByMerchant || reduced.matches;
    let observer;
    const frames = new Set();
    const resetCards = () => root.querySelectorAll('[data-tilt]').forEach(card => {
      card.style.removeProperty('--tilt-x'); card.style.removeProperty('--tilt-y');
      card.style.removeProperty('--foil-x'); card.style.removeProperty('--foil-y');
    });
    const updateMotion = () => {
      const off = paused || reduced.matches;
      root.dataset.motion = off ? 'off' : 'on';
      if (button) {
        button.setAttribute('aria-pressed', String(off));
        button.innerHTML = off ? '<span aria-hidden="true">▷</span> Resume animation' : '<span aria-hidden="true">Ⅱ</span> Pause animation';
        button.hidden = reduced.matches || !enabledByMerchant;
      }
      if (off) resetCards();
    };
    button?.addEventListener('click', () => { paused = !paused; updateMotion(); }, {signal});
    reduced.addEventListener('change', updateMotion, {signal});
    updateMotion();
    if ('IntersectionObserver' in window && !paused && !reduced.matches) {
      observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) {
          entry.target.classList.remove('onami-reveal-pending');
          observer.unobserve(entry.target);
        }
      }, {threshold:0.08});
      root.querySelectorAll('[data-reveal]').forEach(el => {
        if (el.getBoundingClientRect().top > window.innerHeight) {
          el.classList.add('onami-reveal-pending'); observer.observe(el);
        }
      });
    }
    root.querySelectorAll('[data-tilt]').forEach(card => {
      let frame = 0;
      card.addEventListener('pointermove', event => {
        if (!pointer.matches || root.dataset.motion === 'off') return;
        if (frame) { cancelAnimationFrame(frame); frames.delete(frame); }
        const x = event.clientX, y = event.clientY;
        frame = requestAnimationFrame(() => {
          frames.delete(frame); frame = 0;
          if (root.dataset.motion === 'off') return;
          const rect = card.getBoundingClientRect();
          const px = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
          const py = Math.max(0, Math.min(1, (y - rect.top) / rect.height));
          card.style.setProperty('--tilt-x', `${(0.5-py)*11}deg`);
          card.style.setProperty('--tilt-y', `${(px-0.5)*11}deg`);
          card.style.setProperty('--foil-x', `${px*100}%`);
          card.style.setProperty('--foil-y', `${py*100}%`);
        }); frames.add(frame);
      }, {signal,passive:true});
      card.addEventListener('pointerleave', () => {
        if (frame) { cancelAnimationFrame(frame); frames.delete(frame); frame=0; }
        card.style.removeProperty('--tilt-x'); card.style.removeProperty('--tilt-y');
      }, {signal});
    });
    active.set(root, () => { events.abort(); observer?.disconnect(); frames.forEach(cancelAnimationFrame); active.delete(root); });
  };
  const mountAll = target => { if (target.matches?.('[data-onami]')) mount(target); target.querySelectorAll('[data-onami]').forEach(mount); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(document), {once:true});
  else mountAll(document);
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    active.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
